export function Findings() {
  // Placeholder
  return null
}
